export default "__VITE_ASSET__DfDtb6Is__"